import React, { ReactNode } from 'react'
import classNames from 'classnames'
import Dialog from '@mui/material/Dialog'
import { makeStyles } from '@mui/styles'
import theme from '@/theme'
import clsx from 'clsx'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import CloseSvg from '@assets/images/icons/v2/close.svg'

const iconSize = '10px'

interface MasterDetailModalProps {
  title?: string;
  subtitle?: string;
  actions?: ReactNode;
  className?: Record<string, string>;
  usePerfectScrollbar?: boolean;
  width?: string;
  height?: string;
  dataQsId: string;
  [key: string]: any; // To allow any additional props
}

const useStyles = makeStyles({
  dialog: (props: MasterDetailModalProps) => ({
    width: props.width || '800px',
    maxWidth: props.width || '800px',
    height: props.height || '600px',
    display: 'flex',
    flexDirection: 'row',
  }),
  title: {
    display: 'flex',
    flexDirection: 'column',
    padding: '30px 40px 0',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '0 40px 30px',
    margin: '0',
  },
  leftContent: {
    width: '60%',
    height: '100%',
  },
  rightContent: {
    width: '40%',
    height: '100%',
    backgroundColor: theme.sidebarColorModal,
  },
  closeButton: {
    border: 0,
    backgroundColor: 'transparent',
    padding: 10,
    margin: '10px 20px',
    outline: 'none',
    position: 'absolute',
    right: 0,
  },
})

const MasterDetailModal: React.FC<MasterDetailModalProps> = (props) => {
  const {
    className: classesExt,
    closeButtonClass,
    leftPanelContent,
    rightPanelContent,
    leftContentClass,
    rightContentClass,
    showCloseIcon,
    onClose,
    dataQsId,
    open,
    disableBackdropClick = true,
    ...otherProps
  } = props

  const classes = useStyles(props)

  const handleClose = (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (disableBackdropClick && reason === 'backdropClick') {
      return
    }
    if (onClose) {
      onClose(event, reason)
    }
  }

  return (
    <div>
      <Dialog
        open={open}
        {...otherProps}
        onClose={handleClose}
        disableEnforceFocus
        scroll="paper"
        classes={{
          paper: classNames(
            classes.dialog,
          ),
          ...classesExt,
        }}
        data-qs-id={dataQsId}
      >
        {showCloseIcon && (
          <button onClick={onClose} className={clsx(classes.closeButton, closeButtonClass)}>
            <SVGIcon svg={CloseSvg} height={iconSize} width={iconSize} fill={theme.white} />
          </button>
        )}
        <div className={clsx(classes.leftContent, leftContentClass)}>
          {leftPanelContent}
        </div>
        <div className={clsx(classes.rightContent, rightContentClass)}>
          {rightPanelContent}
        </div>
      </Dialog>
    </div>

  )
}

export default MasterDetailModal
